export default "__VITE_ASSET__D38d67$n__"